const RESET_SIGNAL = "reset_search";
export default RESET_SIGNAL;
